module.exports = __webpack_public_path__ + "static/media/bt.c46b3334.svg";